var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("app-header-dados-processo", {
            attrs: {
              processo: _vm.processo,
              isCCR: _vm.isCCR,
              dadosCadastros: _vm.dadosCadastros
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Dados do DAR:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Prestação (PMT):",
                      content: _vm.parcela.numero,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Data de Emissão:",
                      content: _vm.parcela.boleto.dataEmissao,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor da Parcela:",
                      content: _vm.parcela.valorFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Total de Correção Anual:",
                      content: _vm.parcela.correcaoFormatada,
                      contentAlignRight: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Número do DAR:",
                      content: _vm.parcela.boleto.numeroDar,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Data de Vencimento:",
                      content: _vm.parcela.dataVencimentoFormatada,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Total de Juros:",
                      content: _vm.parcela.jurosFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor total do DAR:",
                      content: _vm.parcela.valorFormatado,
                      contentAlignRight: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b1c30d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b1c30d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/VisualizarDar.vue
// module id = null
// module chunks = 